{
  "recordingDashboard": {
    "title": "Felvételi vezérlőpult",
    "subtitle": "Kövesd nyomon az összes folyamat felvételi állapotát, és kezeld a nyitott hozzárendeléseket.",
    "progress": {
      "title": "Felvételi folyamat ({{count}} folyamat)",
      "completed": "Befejezett",
      "inRecording": "Felvétel alatt",
      "recordingComplete": "Felvéve",
      "notStarted": "Nem indított",
      "pendingAssignment": "Függőben"
    },
    "tabs": {
      "notStarted": "Nem indított",
      "inRecording": "Felvétel alatt",
      "completed": "Befejezett"
    },
    "notStarted": {
      "startRecording": "Felvétel indítása",
      "overdue": "Lejárt",
      "noProcesses": "Minden folyamat elindult."
    },
    "inRecording": {
      "reassign": "Újra hozzárendelés",
      "noProcesses": "Jelenleg nincs felvétel alatt álló folyamat.",
      "pendingStep": "Függőben lévő hozzárendelés",
      "openStep": "Nyitott lépés"
    },
    "completed": {
      "noProcesses": "Még nincsenek befejezett folyamatok."
    },
    "surveys": {
      "pending": "Függőben",
      "completed": "Befejezett",
      "dismissed": "Nem végzi a lépést"
    },
    "actions": {
      "openProcess": "Folyamat megnyitása",
      "toggleDetails": "Részletek megjelenítése"
    },
    "columns": {
      "process": "Folyamat",
      "owner": "Tulajdonos",
      "status": "Státusz",
      "statusRecording": "Felvételi státusz",
      "step": "Lépés",
      "actions": "Műveletek",
      "unassigned": "Nincs hozzárendelve",
      "dueDate": "Határidő",
      "type": "Típus",
      "assignee": "Felelős"
    },
    "subTable": {
      "step": "Lépés",
      "survey": "Kérdőív",
      "hideCompleted": "Befejezettek elrejtése",
      "assignment": "Hozzárendelés",
      "cannotNudgeNonPerson": "Csak személyeknek küldhet emlékeztetőt."
    },
    "status": {
      "openAssignments_one": "{{count}} függőben lévő hozzárendelés",
      "openAssignments_other": "{{count}} függőben lévő hozzárendelés",
      "inRecordingSteps": "{{count}} lépés felvétel alatt",
      "pendingSurveys": "{{count}} függőben lévő kérdőív",
      "overdue": "{{count}} lejárt",
      "stepsComplete": "{{completed}}/{{total}} lépés felvéve",
      "stepsTooltip": "Felvett lépések / összes ismert lépés"
    },
    "nudge": {
      "title": "Emlékeztető küldése",
      "description": "Emlékeztető küldése {{name}} részére a(z) {{process}} felvételi feladatáról.",
      "messagePlaceholder": "Személyes üzenet hozzáadása...",
      "send": "Emlékeztető küldése",
      "success": "Emlékeztető sikeresen elküldve."
    }
  }
}
